<script>import { createEventDispatcher, onMount, tick } from "svelte";
const dispatch = createEventDispatcher();
export let SvelteComponent;
export let props;
export let children;
export let events;
let slot = void 0;
let instance;
$:
  instance && syncEvents(events);
let offs = [];
function syncEvents(listeners) {
  offs.forEach((off) => off());
  offs = [];
  if (listeners) {
    Object.entries(listeners).forEach(([event, listener]) => {
      offs.push(instance.$on(event, listener));
    });
  }
}
$:
  dispatch("svelte-slot", slot);
onMount(() => {
  tick().then(() => {
    dispatch("svelte-slot", slot);
  });
});
</script>

{#if children}
  <svelte:component this={SvelteComponent} bind:this={instance} {...props}
    ><svelte-slot bind:this={slot} /></svelte:component
  >
{:else}
  <svelte:component this={SvelteComponent} bind:this={instance} {...props} />
{/if}

<style>
  svelte-slot {
    display: contents;
  }
</style>
